import { render, staticRenderFns } from "./TTButton.vue?vue&type=template&id=17533916&scoped=true&"
import script from "./TTButton.vue?vue&type=script&lang=js&"
export * from "./TTButton.vue?vue&type=script&lang=js&"
import style0 from "./TTButton.vue?vue&type=style&index=0&id=17533916&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17533916",
  null
  
)

export default component.exports